import { AfterViewInit, Component, ElementRef, Inject, OnDestroy, Optional, Renderer2 } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

import { BaseDialog } from '../base.dialog';
import { ParentEvents } from '../../../utils/parent-events.service';


export interface ConfirmSignatureDialogData {
   // data: ConfirmSignatureDialogData;
   // participants: any;
   phone: string;
   single: boolean;
}

@Component({
    templateUrl: './confirm-signature.dialog.html',
    styleUrls: ['./confirm-signature.dialog.scss'],
})
export class ConfirmSignatureDialog extends BaseDialog implements AfterViewInit, OnDestroy {
    constructor(
        el: ElementRef,
        parentEvents: ParentEvents,
        renderer: Renderer2,
        private dialogRef: MatDialogRef<ConfirmSignatureDialog>,
        @Optional()
        @Inject(MAT_DIALOG_DATA)
        public data: ConfirmSignatureDialogData

    ) {
        super(parentEvents, el, renderer);
    }

    onClose() {
        this.dialogRef.close(false);
    }

    onSubmit() {
        this.dialogRef.close(true);
    }
}
